import { render, staticRenderFns } from "./Changeitemslist.vue?vue&type=template&id=412e5602&scoped=true&"
import script from "./Changeitemslist.vue?vue&type=script&lang=js&"
export * from "./Changeitemslist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412e5602",
  null
  
)

export default component.exports